import MaterialAddOutlined from '@mui/icons-material/AddOutlined';
import MaterialAppsOutlined from '@mui/icons-material/AppsOutlined';
import MaterialArrowBack from '@mui/icons-material/ArrowBack';
import MaterialArrowDownward from '@mui/icons-material/ArrowDownward';
import MaterialArrowDownwardOutlined from '@mui/icons-material/ArrowDownwardOutlined';
import MaterialArrowDropDown from '@mui/icons-material/ArrowDropDown';
import MaterialArrowForward from '@mui/icons-material/ArrowForward';
import MaterialArrowUpward from '@mui/icons-material/ArrowUpward';
import MaterialBarChart from '@mui/icons-material/BarChart';
import MaterialBlockOutlined from '@mui/icons-material/BlockOutlined';
import MaterialBlurOnOutlined from '@mui/icons-material/BlurOnOutlined';
import MaterialBrokenImageOutlined from '@mui/icons-material/BrokenImageOutlined';
import MaterialChat from '@mui/icons-material/Chat';
import MaterialCheckBox from '@mui/icons-material/CheckBox';
import MaterialCheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import MaterialChevronLeft from '@mui/icons-material/ChevronLeft';
import MaterialChevronRight from '@mui/icons-material/ChevronRight';
import MaterialClose from '@mui/icons-material/Close';
import MaterialCloseOutlined from '@mui/icons-material/CloseOutlined';
import MaterialCloudOff from '@mui/icons-material/CloudOff';
import MaterialContentCopy from '@mui/icons-material/ContentCopy';
import MaterialDevicesOther from '@mui/icons-material/DevicesOther';
import MaterialEmailOutlined from '@mui/icons-material/EmailOutlined';
import MaterialErrorOutline from '@mui/icons-material/ErrorOutline';
import MaterialExitToApp from '@mui/icons-material/ExitToApp';
import MaterialFirstPage from '@mui/icons-material/FirstPage';
import MaterialFormatBold from '@mui/icons-material/FormatBold';
import MaterialFormatItalic from '@mui/icons-material/FormatItalic';
import MaterialFormatListBulleted from '@mui/icons-material/FormatListBulleted';
import MaterialFormatUnderlined from '@mui/icons-material/FormatUnderlined';
import MaterialGppBad from '@mui/icons-material/GppBad';
import MaterialGraphicEq from '@mui/icons-material/GraphicEq';
import MaterialHourglassEmpty from '@mui/icons-material/HourglassEmpty';
import MaterialIndeterminateCheckBox from '@mui/icons-material/IndeterminateCheckBox';
import MaterialInsightsOutlined from '@mui/icons-material/InsightsOutlined';
import MaterialInterpreterMode from '@mui/icons-material/InterpreterMode';
import MaterialInterpreterModeOutlined from '@mui/icons-material/InterpreterModeOutlined';
import MaterialKeyboardOutlined from '@mui/icons-material/KeyboardOutlined';
import MaterialLanguageOutlined from '@mui/icons-material/LanguageOutlined';
import MaterialLastPage from '@mui/icons-material/LastPage';
import MaterialLockOutlined from '@mui/icons-material/LockOutlined';
import MaterialMenuOutlined from '@mui/icons-material/MenuOutlined';
import MaterialMic from '@mui/icons-material/Mic';
import MaterialMicNone from '@mui/icons-material/MicNone';
import MaterialMicOff from '@mui/icons-material/MicOff';
import MaterialNotes from '@mui/icons-material/Notes';
import MaterialOpenInNew from '@mui/icons-material/OpenInNew';
import MaterialPriorityHigh from '@mui/icons-material/PriorityHigh';
import MaterialRecordVoiceOver from '@mui/icons-material/RecordVoiceOver';
import MaterialRefresh from '@mui/icons-material/Refresh';
import MaterialRemove from '@mui/icons-material/Remove';
import MaterialScienceOutlined from '@mui/icons-material/ScienceOutlined';
import MaterialSendOutlined from '@mui/icons-material/SendOutlined';
import MaterialSentimentVerySatisfiedOutlined from '@mui/icons-material/SentimentVerySatisfiedOutlined';
import MaterialThumbDownOutlined from '@mui/icons-material/ThumbDownOutlined';
import MaterialThumbUpOutlined from '@mui/icons-material/ThumbUpOutlined';
import MaterialVideocamOff from '@mui/icons-material/VideocamOff';
import MaterialVolumeOff from '@mui/icons-material/VolumeOff';
import MaterialWebAssetOff from '@mui/icons-material/WebAssetOff';
import { createMaterialIcon } from 'common/theme/utils';

import { swap } from './phosphorMapping';

/**
 * The `@mui/icons-material` glyphs that used to be imported directly by feature code (HNS-262).
 *
 * They live here rather than in `index.ts` purely to keep that file about the icon set proper: these
 * are the tail, reached by one or two screens each, and several exist only because a Material glyph
 * and one of our local SVGs share a name without sharing a drawing.
 *
 * Folding them in is what makes the visual refresh coherent. A glyph imported straight from
 * `@mui/icons-material` cannot be swapped by anything, so with the flag on those screens would mix
 * Phosphor and Material side by side. Routing every icon through the barrel is now enforced by the
 * `no-restricted-imports` rule for `@mui/icons-material` in `.oxlintrc.json`.
 *
 * The nine `Material*`-prefixed exports are duplicates by construction. Material Icons `Close` and
 * our `Close.svg` are different drawings — the former geometric, the latter Material Symbols-derived
 * and optically corrected — so collapsing them would move flag-off pixels on screens nobody is
 * looking at in this change. The prefix keeps the duplication greppable.
 *
 * TODO(HNS-264): take each `Material*` pair to design and keep one.
 */

export const AppsOutlinedIcon = createMaterialIcon(
  MaterialAppsOutlined,
  'AppsOutlined',
  'AppsOutlined',
  swap('AppsOutlinedIcon')
);
export const LanguageOutlinedIcon = createMaterialIcon(
  MaterialLanguageOutlined,
  'LanguageOutlined',
  'LanguageOutlined',
  swap('LanguageOutlinedIcon')
);
export const LockOutlinedIcon = createMaterialIcon(
  MaterialLockOutlined,
  'LockOutlined',
  'LockOutlined',
  swap('LockOutlinedIcon')
);
export const MenuOutlinedIcon = createMaterialIcon(
  MaterialMenuOutlined,
  'MenuOutlined',
  'MenuOutlined',
  swap('MenuOutlinedIcon')
);
export const CloudOffIcon = createMaterialIcon(MaterialCloudOff, 'CloudOff', 'CloudOff', swap('CloudOffIcon'));
export const DevicesOtherIcon = createMaterialIcon(
  MaterialDevicesOther,
  'DevicesOther',
  'DevicesOther',
  swap('DevicesOtherIcon')
);
export const ErrorOutlineIcon = createMaterialIcon(
  MaterialErrorOutline,
  'ErrorOutline',
  'ErrorOutline',
  swap('ErrorOutlineIcon')
);
export const GppBadIcon = createMaterialIcon(MaterialGppBad, 'GppBad', 'GppBad', swap('GppBadIcon'));
export const HourglassEmptyIcon = createMaterialIcon(
  MaterialHourglassEmpty,
  'HourglassEmpty',
  'HourglassEmpty',
  swap('HourglassEmptyIcon')
);
export const MicNoneIcon = createMaterialIcon(MaterialMicNone, 'MicNone', 'MicNone', swap('MicNoneIcon'));
export const OpenInNewIcon = createMaterialIcon(MaterialOpenInNew, 'OpenInNew', 'OpenInNew', swap('OpenInNewIcon'));
export const VolumeOffIcon = createMaterialIcon(MaterialVolumeOff, 'VolumeOff', 'VolumeOff', swap('VolumeOffIcon'));
export const WebAssetOffIcon = createMaterialIcon(
  MaterialWebAssetOff,
  'WebAssetOff',
  'WebAssetOff',
  swap('WebAssetOffIcon')
);
export const PriorityHighIcon = createMaterialIcon(
  MaterialPriorityHigh,
  'PriorityHigh',
  'PriorityHigh',
  swap('PriorityHighIcon')
);
export const EmailOutlinedIcon = createMaterialIcon(
  MaterialEmailOutlined,
  'EmailOutlined',
  'EmailOutlined',
  swap('EmailOutlinedIcon')
);
export const InsightsOutlinedIcon = createMaterialIcon(
  MaterialInsightsOutlined,
  'InsightsOutlined',
  'InsightsOutlined',
  swap('InsightsOutlinedIcon')
);
export const InterpreterModeOutlinedIcon = createMaterialIcon(
  MaterialInterpreterModeOutlined,
  'InterpreterModeOutlined',
  'InterpreterModeOutlined',
  swap('InterpreterModeOutlinedIcon')
);
export const InterpreterModeIcon = createMaterialIcon(
  MaterialInterpreterMode,
  'InterpreterMode',
  'InterpreterMode',
  swap('InterpreterModeIcon')
);
export const SentimentVerySatisfiedOutlinedIcon = createMaterialIcon(
  MaterialSentimentVerySatisfiedOutlined,
  'SentimentVerySatisfiedOutlined',
  'SentimentVerySatisfiedOutlined',
  swap('SentimentVerySatisfiedOutlinedIcon')
);
export const ArrowDownwardOutlinedIcon = createMaterialIcon(
  MaterialArrowDownwardOutlined,
  'ArrowDownwardOutlined',
  'ArrowDownwardOutlined',
  swap('ArrowDownwardOutlinedIcon')
);
export const ScienceOutlinedIcon = createMaterialIcon(
  MaterialScienceOutlined,
  'ScienceOutlined',
  'ScienceOutlined',
  swap('ScienceOutlinedIcon')
);
export const RefreshIcon = createMaterialIcon(MaterialRefresh, 'Refresh', 'Refresh', swap('RefreshIcon'));
export const KeyboardOutlinedIcon = createMaterialIcon(
  MaterialKeyboardOutlined,
  'KeyboardOutlined',
  'KeyboardOutlined',
  swap('KeyboardOutlinedIcon')
);
export const NotesIcon = createMaterialIcon(MaterialNotes, 'Notes', 'Notes', swap('NotesIcon'));
export const GraphicEqIcon = createMaterialIcon(MaterialGraphicEq, 'GraphicEq', 'GraphicEq', swap('GraphicEqIcon'));
export const SendOutlinedIcon = createMaterialIcon(
  MaterialSendOutlined,
  'SendOutlined',
  'SendOutlined',
  swap('SendOutlinedIcon')
);
export const MicIcon = createMaterialIcon(MaterialMic, 'Mic', 'Mic', swap('MicIcon'));
export const ArrowDownwardIcon = createMaterialIcon(
  MaterialArrowDownward,
  'ArrowDownward',
  'ArrowDownward',
  swap('ArrowDownwardIcon')
);
export const ArrowUpwardIcon = createMaterialIcon(
  MaterialArrowUpward,
  'ArrowUpward',
  'ArrowUpward',
  swap('ArrowUpwardIcon')
);
export const RemoveIcon = createMaterialIcon(MaterialRemove, 'Remove', 'Remove', swap('RemoveIcon'));
export const ArrowDropDownIcon = createMaterialIcon(
  MaterialArrowDropDown,
  'ArrowDropDown',
  'ArrowDropDown',
  swap('ArrowDropDownIcon')
);
export const FormatBoldIcon = createMaterialIcon(
  MaterialFormatBold,
  'FormatBold',
  'FormatBold',
  swap('FormatBoldIcon')
);
export const FormatItalicIcon = createMaterialIcon(
  MaterialFormatItalic,
  'FormatItalic',
  'FormatItalic',
  swap('FormatItalicIcon')
);
export const FormatListBulletedIcon = createMaterialIcon(
  MaterialFormatListBulleted,
  'FormatListBulleted',
  'FormatListBulleted',
  swap('FormatListBulletedIcon')
);
export const FormatUnderlinedIcon = createMaterialIcon(
  MaterialFormatUnderlined,
  'FormatUnderlined',
  'FormatUnderlined',
  swap('FormatUnderlinedIcon')
);
export const ContentCopyIcon = createMaterialIcon(
  MaterialContentCopy,
  'ContentCopy',
  'ContentCopy',
  swap('ContentCopyIcon')
);
export const ThumbUpOutlinedIcon = createMaterialIcon(
  MaterialThumbUpOutlined,
  'ThumbUpOutlined',
  'ThumbUpOutlined',
  swap('ThumbUpOutlinedIcon')
);
export const ThumbDownOutlinedIcon = createMaterialIcon(
  MaterialThumbDownOutlined,
  'ThumbDownOutlined',
  'ThumbDownOutlined',
  swap('ThumbDownOutlinedIcon')
);
export const ArrowBackIcon = createMaterialIcon(MaterialArrowBack, 'ArrowBack', 'ArrowBack', swap('ArrowBackIcon'));
export const ArrowForwardIcon = createMaterialIcon(
  MaterialArrowForward,
  'ArrowForward',
  'ArrowForward',
  swap('ArrowForwardIcon')
);
export const AddOutlinedIcon = createMaterialIcon(
  MaterialAddOutlined,
  'AddOutlined',
  'AddOutlined',
  swap('AddOutlinedIcon')
);
export const BrokenImageOutlinedIcon = createMaterialIcon(
  MaterialBrokenImageOutlined,
  'BrokenImageOutlined',
  'BrokenImageOutlined',
  swap('BrokenImageOutlinedIcon')
);
export const CloseOutlinedIcon = createMaterialIcon(
  MaterialCloseOutlined,
  'CloseOutlined',
  'CloseOutlined',
  swap('CloseOutlinedIcon')
);
export const BlockOutlinedIcon = createMaterialIcon(
  MaterialBlockOutlined,
  'BlockOutlined',
  'BlockOutlined',
  swap('BlockOutlinedIcon')
);
export const BlurOnOutlinedIcon = createMaterialIcon(
  MaterialBlurOnOutlined,
  'BlurOnOutlined',
  'BlurOnOutlined',
  swap('BlurOnOutlinedIcon')
);
export const MaterialCloseIcon = createMaterialIcon(MaterialClose, 'Close', 'MaterialClose', swap('MaterialCloseIcon'));
export const MaterialChevronLeftIcon = createMaterialIcon(
  MaterialChevronLeft,
  'ChevronLeft',
  'MaterialChevronLeft',
  swap('MaterialChevronLeftIcon')
);
export const MaterialChevronRightIcon = createMaterialIcon(
  MaterialChevronRight,
  'ChevronRight',
  'MaterialChevronRight',
  swap('MaterialChevronRightIcon')
);
export const MaterialExitToAppIcon = createMaterialIcon(
  MaterialExitToApp,
  'ExitToApp',
  'MaterialExitToApp',
  swap('MaterialExitToAppIcon')
);
export const MaterialMicOffIcon = createMaterialIcon(
  MaterialMicOff,
  'MicOff',
  'MaterialMicOff',
  swap('MaterialMicOffIcon')
);
export const MaterialVideocamOffIcon = createMaterialIcon(
  MaterialVideocamOff,
  'VideocamOff',
  'MaterialVideocamOff',
  swap('MaterialVideocamOffIcon')
);
export const MaterialBarChartIcon = createMaterialIcon(
  MaterialBarChart,
  'BarChart',
  'MaterialBarChart',
  swap('MaterialBarChartIcon')
);
export const MaterialChatIcon = createMaterialIcon(MaterialChat, 'Chat', 'MaterialChat', swap('MaterialChatIcon'));
export const MaterialRecordVoiceOverIcon = createMaterialIcon(
  MaterialRecordVoiceOver,
  'RecordVoiceOver',
  'MaterialRecordVoiceOver',
  swap('MaterialRecordVoiceOverIcon')
);

export const CheckBoxOutlineBlankIcon = createMaterialIcon(
  MaterialCheckBoxOutlineBlank,
  'CheckBoxOutlineBlank',
  'CheckBoxOutlineBlank',
  swap('CheckBoxOutlineBlankIcon')
);
export const CheckBoxIcon = createMaterialIcon(MaterialCheckBox, 'CheckBox', 'CheckBox', swap('CheckBoxIcon'));
export const IndeterminateCheckBoxIcon = createMaterialIcon(
  MaterialIndeterminateCheckBox,
  'IndeterminateCheckBox',
  'IndeterminateCheckBox',
  swap('IndeterminateCheckBoxIcon')
);
export const FirstPageIcon = createMaterialIcon(MaterialFirstPage, 'FirstPage', 'FirstPage', swap('FirstPageIcon'));
export const LastPageIcon = createMaterialIcon(MaterialLastPage, 'LastPage', 'LastPage', swap('LastPageIcon'));
